import React from 'react';
import { useNavigate } from 'react-router';
import { Typography } from '@naf-simba/building-blocks-typography';
import { Link } from '@naf-simba/elements-links';
import { useLoginRedirect } from '../../../../../../../hooks/useLoginRedirect';
import { VehicleInspectionType } from '../../../../../../../../../types/vehicleInspectionType';
import { VehicleInspectionContextKey } from '../VehicleInspection.utils';
import * as S from './VehicleAlerts.styles';

interface VehicleAlertsProps {
  callToAction: VehicleInspectionType['callToAction'];
  selectedContextKey?: VehicleInspectionContextKey;
}

const MY_VEHICLES_PATH = '/mitt-naf/mine-kjoretoy';

export const VehicleAlerts = ({ callToAction, selectedContextKey }: VehicleAlertsProps) => {
  const navigate = useNavigate();
  const { redirectToLoginPage } = useLoginRedirect();

  if (!callToAction) {
    return null;
  }

  const handleActivateAlerts = () => {
    navigate(MY_VEHICLES_PATH);
  };

  const handleLogIn = () => {
    redirectToLoginPage(MY_VEHICLES_PATH);
  };

  if (callToAction.action === 'Booking' && callToAction.booking) {
    const { booking } = callToAction;
    const isDueSoon = selectedContextKey === VehicleInspectionContextKey.DueSoon;

    return (
      <S.VehicleAlertsWrapper>
        <S.BookToday variant="headlineXXXS">Bestill time til EU-kontroll i dag!</S.BookToday>
        <S.PriceBlock>
          <Typography>Medlemspris: {booking.memberPrice},-</Typography>
          <Typography>Ikke-medlem: {booking.nonMemberPrice},-</Typography>
        </S.PriceBlock>
        <S.BookEarly>
          {isDueSoon
            ? 'Fristen nærmer seg - det kan bli fullt, så vær tidlig ute'
            : 'Det blir fort fullt hos våre NAF sentre. Det lønner seg derfor å være tidlig ute.'}
        </S.BookEarly>
        <S.StyledButton href={booking.link.data.href} target={booking.link.data.blank ? '_blank' : '_self'}>
          Finn ledig time
        </S.StyledButton>
      </S.VehicleAlertsWrapper>
    );
  }

  return (
    <S.VehicleAlertsWrapper>
      <Typography>Ønsker du å bli varslet når fristen nærmer seg?</Typography>
      {callToAction.link && callToAction.action === 'ActivateAlerts' && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid -- Link used as a non-navigating action
        <Link onClick={handleActivateAlerts} text="Aktiver varslinger i Mine Kjøretøy" />
      )}
      {callToAction.link && callToAction.action === 'LogIn' && (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid -- Link used as a non-navigating action
        <Link onClick={handleLogIn} text="Logg inn for å aktivere varsling i Mine Kjøretøy" />
      )}
    </S.VehicleAlertsWrapper>
  );
};
